export default __webpack_public_path__ + "static/media/expert02.bbf875ef.jpg";